/** @internal */
export const OP_BACK_PRESSURE = "BackPressure";
/** @internal */
export const OP_BUFFER_SLIDING = "BufferSliding";
//# sourceMappingURL=channelMergeStrategy.js.map